import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=83202518"
import script from "./downloads.vue?vue&type=script&lang=js"
export * from "./downloads.vue?vue&type=script&lang=js"
import style0 from "./downloads.vue?vue&type=style&index=0&id=83202518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports